import React, { ChangeEvent } from 'react';

import HintModal from '../../containers/hints/hint-modal';
import Datepicker from '../../modules/datepicker/datepicker/datepicker';
import UiSearchInput from '../../modules/ui/ui-search-input/ui-search-input';
import UiSelect, { OptionType } from '../../modules/ui/ui-select/ui-select';

import './orders-filters.scss';

interface OrdersFiltersProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  roles: { value: string; label: string }[];
  statuses: { value: string; label: string }[];
  onRoleSelect: (value: string) => void;
  onStatusSelect: (value: string) => void;
  selectedRole: string;
  selectedStatus: string;
  period: {
    from: Date | null;
    to: Date | null;
  };
  onPeriodChange: (period: { from: Date | null; to: Date | null }) => void;
}

const SEARCH_FILTER_PLACEHOLDER = 'Поиск номер, компания, инн';

const OrdersFilters: React.FC<OrdersFiltersProps> = ({
  onSearchQueryChange,
  period,
  onPeriodChange,
  selectedRole,
  selectedStatus,
  onStatusSelect,
  onRoleSelect,
  searchQuery,
  roles,
  statuses,
}) => {
  const onQueryChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSearchQueryChange(e.target.value);
  };

  const getSelectOption = () =>
    roles.find((item) => item.value === selectedRole);

  // const getSelectOptionsArr = (
  //   value: string[],
  //   data: { value: string; label: string }[]
  // ) => data.filter((item) => value.includes(item.value));

  return (
    <div className="filter justify-between nowrap">
      <div className="filter__container">
        <div className="filter__item filter__item--sm">
          <UiSelect
            sm
            value={getSelectOption()}
            options={roles}
            placeholder="Выберите роль"
            onChange={(val) => {
              if (!Array.isArray(val) && val) {
                onRoleSelect(val.value);
              }
            }}
          />
        </div>
        <div className="filter__item filter__item--xl">
          <UiSearchInput
            sm
            value={searchQuery}
            onChange={onQueryChange}
            placeholder={SEARCH_FILTER_PLACEHOLDER}
          />
        </div>
        <div className="filter__item filter__item--lg">
          <Datepicker
            sm
            type="range"
            period={period}
            onPeriodChange={(range) => {
              onPeriodChange({
                from: range.start || null,
                to: range.end || null,
              });
            }}
          />
        </div>
        <div className="filter__item filter__item--sm">
          <UiSelect
            sm
            value={statuses.find((s) => s.value === selectedStatus)}
            placeholder="Выберите статус"
            options={statuses}
            onChange={(val) => onStatusSelect((val as OptionType)?.value)}
          />
        </div>
      </div>

      <HintModal hint="ORDER_LIST" />
    </div>
  );
};
export default OrdersFilters;
